import React, { Component } from 'react'
import ReactTooltip from 'react-tooltip'
import './tooltip.scss'

export class Tooltip extends Component {
  render() {
    return (
      <>
        <ReactTooltip id={this.props.id} place="top" effect="solid" type='info' className={this.props.className ? `_tooltip ${this.props.className}` : '_tooltip'}>
          <span style={{fontSize: this.props.fontSize || "16px"}}>{this.props.data}</span>
        </ReactTooltip>
      </>
    )
  }
}

export default Tooltip
